import AreaNewsListPage from './AreaNewsListPage';

export default AreaNewsListPage;
